import React from 'react';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Close from '@mui/icons-material/Close';

import { AppState } from '../states/appState';
import { ViewerState } from '../states/viewerState'
import MainMenuContaner from '../containers/mainMenuContaner';

import { styled } from '@mui/material/styles'

interface OwnProps { }
type AppBarProps = OwnProps & AppState & ViewerState;

const GovName = styled(Typography)(({ theme }) => ({
    flexGrow: 1,
    display: 'none',
    [theme.breakpoints.up('sm')]: {
        display: 'block',
    },
}));

export const SampleAppBar: React.FC<AppBarProps> = (props: AppBarProps) => {

    const closeWindow = () => {
        window.close();
    };

    return (
        <Box sx={{
            flexGrow: 1,
            height: (theme) => theme.spacing(10),
        }}>
            <AppBar position="fixed" sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
            }}>
                <Toolbar>
                    <MainMenuContaner />
                    <GovName variant="h6" noWrap>
                        {props.title}
                    </GovName>
                    <div>
                        <Tooltip title="ウィンドウを閉じる">
                            <IconButton
                                onClick={closeWindow}
                                color="inherit"
                            >
                                <Close />
                            </IconButton>
                        </Tooltip>
                    </div>
                </Toolbar>
            </AppBar>
        </Box>
    );
}
